export default function Link() {
  return {
    MuiLink: {
      styleOverrides: {
        underlineAlways: {
          cursor: 'pointer',
        },
      },
    },
  };
}
